import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PageFixBrokenLinkService } from '@client/app/modules/page-fix/forms/broken-link/service/broken-link.service';
import { LinksRepoService, OriginalUrlsType } from '@client/app/services/api/links-repo/links-repo.service';
import { PageFixRepoService } from '@client/app/services/api/pagefix-repo/page-fix-repo.service';
import { PAGE_FIX_FIXABLE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-fixable-types';

@Component({
    selector: 'page-fix-form-broken-link',
    templateUrl: './page-fix-form-broken-link.component.html',
    standalone: false,
})
export class PageFixFormBrokenLinkComponent implements OnInit {
    @Input() resolve: any;
    @Output() close = new EventEmitter<any>();
    @Output() dismiss = new EventEmitter<void>();

    loading = true;
    urls: OriginalUrlsType[] = [];
    linkReplacement = '';
    service = new PageFixBrokenLinkService();

    constructor (
        private linksRepoService: LinksRepoService,
        private pageFixRepoService: PageFixRepoService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.loading = true;
        this.urls = [];
        this.linkReplacement = '';
        this.service = new PageFixBrokenLinkService();
        this.service.setModel(this.resolve.model);
        this.service.setPageFix(this.resolve.pageFix);
        this.service.setFixableId(this.resolve.typeId || this.resolve.model.id);
        this.linkReplacement = this.service.getLinkReplacement();
        this.getOriginalUrls()
            .then((urls: any) => {
                this.urls = urls;
                this.service.parseQuerySelector(urls);
            })
            .catch(() => {
                // Handle error silently (angular.noop equivalent)
            })
            .finally(() => {
                this.loading = false;
            });
    }

    submit (): void {
        let promise: Promise<any>;
        const change = {
            value: this.linkReplacement,
            attribute: this.service.getAttribute(),
        };
        const selector = this.service.getSelector();
        const pageFix = this.service.getPageFix();

        if (pageFix) {
            promise = this.pageFixRepoService.update(pageFix, { change: change, selector }, {});
        } else {
            const fixableId = this.service.getFixableId();
            const createData: any = {
                change: change,
                selector: selector,
                fixable_type: PAGE_FIX_FIXABLE_TYPES.link,
                change_type: this.service.getChangeType(),
            };
            if (fixableId !== null) {
                createData.fixable_id = fixableId;
            }
            promise = this.pageFixRepoService.create(createData, null);
        }

        promise.then((pageFixResult: any) => {
            this.closeModal(pageFixResult);
        });
    }

    cancel (): void {
        this.dismiss.emit();
    }

    private closeModal (result: any): void {
        this.close.emit(result);
    }

    private getOriginalUrls (): Promise<OriginalUrlsType[]> {
        const fixableId = this.service.getFixableId();
        if (fixableId !== null) {
            return this.linksRepoService.getOriginalUrls({ id: fixableId });
        }
        return this.linksRepoService.getOriginalUrls({});
    }
}
